
import React from 'react';
import { Button } from '@/components/ui/button';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from '@/components/ui/dropdown-menu';
import { 
  MoreHorizontal,
  ExternalLink,
  Crown,
  Eye,
  EyeOff,
  RefreshCw,
  Trash2,
  UserX,
  Shield
} from 'lucide-react';

interface UserActionsDropdownProps {
  user: any;
  currentUserIsAdmin: boolean;
  onViewProfile: (username: string) => void;
  onUserAction: (action: string, userId: string) => void;
  onResetAccount: (user: any) => void;
  onManageRole?: (user: any) => void;
}

const UserActionsDropdown: React.FC<UserActionsDropdownProps> = ({
  user,
  currentUserIsAdmin,
  onViewProfile,
  onUserAction,
  onResetAccount,
  onManageRole
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="text-white hover:bg-white/10">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-black border-white/20">
        <DropdownMenuItem 
          onClick={() => onViewProfile(user.username)}
          className="text-white hover:bg-white/10 focus:bg-white/10 cursor-pointer"
        >
          <ExternalLink className="h-4 w-4 mr-2" />
          Ver Perfil
        </DropdownMenuItem>
        {onManageRole && (
          <DropdownMenuItem 
            onClick={() => onManageRole(user)}
            className="text-blue-400 hover:bg-blue-500/10 focus:bg-blue-500/10"
          >
            <Shield className="h-4 w-4 mr-2" />
            Gerenciar Role
          </DropdownMenuItem>
        )}
        <DropdownMenuItem 
          onClick={() => onUserAction('open-actions', user.id)}
          className="text-white hover:bg-white/10 focus:bg-white/10"
        >
          <Eye className="h-4 w-4 mr-2" />
          Ações do Usuário
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => onUserAction('toggle-visibility', user.id)}
          className="text-white hover:bg-white/10 focus:bg-white/10"
        >
          {user.hidden ? <Eye className="h-4 w-4 mr-2" /> : <EyeOff className="h-4 w-4 mr-2" />}
          {user.hidden ? 'Mostrar' : 'Ocultar'}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => onUserAction('reset-onboarding', user.id)}
          className="text-white hover:bg-white/10 focus:bg-white/10"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Resetar Onboarding
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => onResetAccount(user)}
          className="text-red-400 hover:bg-red-500/10 focus:bg-red-500/10"
        >
          <Trash2 className="h-4 w-4 mr-2" />
          Zerar Conta
        </DropdownMenuItem>
        {currentUserIsAdmin ? (
          <DropdownMenuItem 
            onClick={() => onUserAction('delete-permanently', user.id)}
            className="text-red-600 hover:bg-red-600/20 focus:bg-red-600/20 font-bold"
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Deletar Permanentemente
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem 
            disabled
            className="text-white/30 opacity-50 cursor-not-allowed"
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Deletar Permanentemente
            <span className="ml-auto text-xs">(Apenas Admin)</span>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onClick={() => onUserAction('suspend', user.id)}
          className="text-red-400 hover:bg-red-500/10 focus:bg-red-500/10"
        >
          <UserX className="h-4 w-4 mr-2" />
          Suspender
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserActionsDropdown;
